// extracted by mini-css-extract-plugin
module.exports = {"avatar":"NavAvatar_avatar__2ZUX7","handles":"NavAvatar_handles__3htBu"};